import * as _ from "lodash-es";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import TitleTagEnum from "../../../models/TitleTagEnum";
import "./OwTitle.scss";

type Props = {
    id?: string;
    title: string;
    leftIconName?: string;
    rightIconName?: string;
    className?: string;
    supplierModel?: any;
    isSupplierVendorOverride?: boolean;
    tag?: TitleTagEnum | string;
    defaultMargins?: boolean;
    disableTranslation?: boolean;
    isBold?: boolean;
    isUnderline?: boolean;
    isItalic?: boolean;
    fn?: any;
    testId?: string;
};

class OwTitle extends Component<Props> {
    static defaultProps = {
        supplierModel: {},
        isSupplierVendorOverride: false,
        tag: TitleTagEnum.H2,
        defaultMargins: true,
        className: "",
    };

    render() {
        let title = this.props.disableTranslation ? this.props.title : _.toLower(this.props.title);

        if (this.props.isSupplierVendorOverride && !_.isNil(this.props.supplierModel.vendor_name_override)) {
            title = this.props.title.replace(/vendor/, this.props.supplierModel.vendor_name_override);
        }

        const translatedTitle = this.props.disableTranslation ? (
            title
        ) : (
            <FormattedMessage id={`${title}`} defaultMessage={`_${title}_`} description="Title Label" />
        );

        const className = (this.props.defaultMargins ? "mt-2 " : " ") + this.props.className;

        const content = (
            <div
                onClick={() => {
                    if (this.props.fn) {
                        this.props.fn();
                    }
                }}>
                <i className={this.props.leftIconName} /> {translatedTitle} <i className={this.props.rightIconName} />
            </div>
        );

        let processedContent = content;

        if (this.props.isBold) {
            processedContent = <b>{processedContent}</b>;
        }

        if (this.props.isItalic) {
            processedContent = <i>{processedContent}</i>;
        }

        if (this.props.isUnderline) {
            processedContent = <u>{processedContent}</u>;
        }

        switch (this.props.tag) {
            case "h1":
                return (
                    <h1 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h1>
                );

            case "h2":
                return (
                    <h2 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h2>
                );

            case "h3":
                return (
                    <h3 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h3>
                );

            case "h4":
                return (
                    <h4 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h4>
                );

            case "h5":
                return (
                    <h5 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h5>
                );

            case "h6":
                return (
                    <h6 id={this.props.id} className={className} data-testid={this.props.testId}>
                        {processedContent}
                    </h6>
                );
        }
    }
}

export default OwTitle;
